.createRecordsModal {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  z-index: 2000;
}

.body {
  height: 100%;
  padding: 50px 40px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow: auto;
  width: 820px;
}

.strings,
.workspace {
  flex-direction: row;
  display: flex;
  flex: 0;
}

.strings {
  margin-top: 2.5em;
}

.label {
  padding-top: 0.5em;
  margin-right: 2em;
  font-weight: 500;
  width: 20%;
  text-align: right;
  color: var(--theme-primary-text);
}

.required {
  color: var(--aha-red-600);
}

.createRecordsModal .selectroWrapper,
.createRecordsModal input {
  width: 470px;
}

.createRecordsModal .editableElement {
  display: flex;
  align-items: center;
  height: 2.5em;
  margin: 0.5em 0;
  width: 470px;
}
